import { axiosPublic, axiosPrivate } from "../utils";
import { toast } from 'react-toastify';

export const createLab = async (data) => {
    const { name } = data;
    try {
        const res = await axiosPrivate.post('lab/create', {
            name: name
        });
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }
        toast.success(res.data.message);

        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}

export const getAllLabs = async () => {
    try {
        const res = await axiosPrivate.get('lab/all');
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }
        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}

export const switchLab = async (data) => {
    const { labId } = data;
    try {
        const res = await axiosPrivate.post('lab/switch-lab', {
            labId: labId
        });
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }
        toast.success(res.data.message);
        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}